import { Category } from "../../category/category";

export class renameCategori {
    i: number;
    categori: Category;
    action: string;
    constructor(i,categori,action = null) {
        this.i = i;
        this.categori = categori;
        this.action = action;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/rename/rename-categori.ts